const FineTuningState = {
  data: {
    fineTuningJobs: [],
    logs: [],
  },
  etc: {
    activeTab: 'fine-tuning',
  },
};

export default FineTuningState;
